
import { Options, Vue } from "vue-class-component";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { mapActions } from "vuex";

@Options({
  components: {},
  computed: {
    sections: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.sections;
      },
    },
  },
  methods: {
    ...mapActions({
      changeTopic: "CHANGE_TOPIC",
      changeMainTopic: "CHANGE_MAIN_TOPIC",
    }),
  },
})
export default class Features extends Vue {}
